module.exports = __webpack_public_path__ + "static/teleport-bg.7dde186b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/thumbs/teleport-bg.png
// module id = ./src/pages/images/thumbs/teleport-bg.png
// module chunks = 35783957827783